import React, { useEffect, useState } from "react";
import { LegalDocumentPage } from "@/components/LegalDocumentPage";
import api from "@/lib/api";
import { LEGAL_OPERATOR, TERMS_SECTIONS } from "@/content/legalHu";
import { interpolateLegalSections } from "@/lib/legalInterpolate";

export default function Terms() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/legal-pages")
      .then((r) => setData(r.data))
      .catch(() =>
        setData({
          operator: LEGAL_OPERATOR,
          terms: {
            title: "Általános Szerződési Feltételek (ÁSZF)",
            sections: interpolateLegalSections(TERMS_SECTIONS, LEGAL_OPERATOR),
          },
        }),
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <LegalDocumentPage
      testId="terms-page"
      loading={loading}
      title={data?.terms?.title || "Általános Szerződési Feltételek (ÁSZF)"}
      description="AutoPark ÁSZF — használtautó hirdetési platform."
      sections={data?.terms?.sections}
      operator={data?.operator}
    />
  );
}
